var map = {
	"./r1.jpg": 125,
	"./r2.jpg": 126,
	"./r3.jpg": 127,
	"./r4.jpg": 128,
	"./r5.jpg": 129,
	"./r6.jpg": 130,
	"./r7.jpg": 131,
	"./r8.jpg": 132,
	"./r9.jpg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;